import React from 'react';
import { motion } from 'framer-motion';

const ProgressIndicator = ({ current, total, onSelect, scenes = [] }) => {
  // Determine if we're in Phase I (scenes 6-11, indices 5-10)
  const getPhaseBreak = () => {
    // Find where Phase I starts
    const phaseIStart = scenes.findIndex(s => s.phase === 'I');
    return phaseIStart > 0 ? phaseIStart : null;
  };

  const phaseBreak = getPhaseBreak();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 2, delay: 0.5 }}
      className="fixed right-4 sm:right-8 top-1/2 -translate-y-1/2 flex flex-col gap-1.5 sm:gap-2 z-10"
    >
      {Array.from({ length: total }).map((_, index) => (
        <React.Fragment key={index}>
          {/* Phase separator - subtle gap before Phase I */}
          {phaseBreak && index === phaseBreak && (
            <div className="h-2 sm:h-3" />
          )}
          
          <button
            onClick={() => onSelect(index)}
            className="group relative p-1 touch-manipulation"
            aria-label={`Go to scene ${index + 1}`}
          >
            <motion.div
              className="w-1 h-1 sm:w-1.5 sm:h-1.5 rounded-full transition-all duration-700"
              initial={false}
              animate={{
                backgroundColor: index === current 
                  ? 'hsl(38, 35%, 55%)' // vaulten-gold
                  : 'hsl(40, 5%, 30%)',  // vaulten-ash (slightly darker)
                scale: index === current ? 1.5 : 1,
                opacity: index === current ? 1 : 0.35
              }}
              whileHover={{ 
                scale: 1.8, 
                opacity: 0.7 
              }}
              whileTap={{ scale: 1.2 }}
              transition={{ duration: 0.5 }}
            />
            
            {/* Tooltip on hover - hidden on mobile */}
            <span 
              className="absolute right-5 sm:right-6 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-50 transition-opacity duration-500 text-[10px] sm:text-xs whitespace-nowrap font-display hidden sm:block" 
              style={{ color: 'hsl(40, 5%, 50%)' }}
            >
              {scenes[index]?.subtitle || `Scene ${index + 1}`}
            </span>
          </button>
        </React.Fragment>
      ))}
    </motion.div>
  );
};

export default ProgressIndicator;
